import {
  buildGameSceneDailyShopData,
  refreshActiveTab,
  refreshAllViews,
  refreshHud,
  refreshOnTabEnter,
  refreshTabLocks,
  refreshTabRedDots,
  type GameSceneRefreshDeps,
} from "./gameSceneRefresh.js";

export interface GameSceneRefreshRuntime {
  all(): void;
  activeTab(): void;
  onTabEnter(): void;
  tabLocks(): void;
  tabRedDots(): void;
  dailyShopData(): ReturnType<typeof buildGameSceneDailyShopData>;
  hud(): void;
}

export function createGameSceneRefreshRuntime(
  deps: () => GameSceneRefreshDeps,
): GameSceneRefreshRuntime {
  return {
    all: () => refreshAllViews(deps()),
    activeTab: () => refreshActiveTab(deps()),
    onTabEnter: () => refreshOnTabEnter(deps()),
    tabLocks: () => refreshTabLocks(deps()),
    tabRedDots: () => refreshTabRedDots(deps()),
    dailyShopData: () => buildGameSceneDailyShopData(deps()),
    hud: () => refreshHud(deps()),
  };
}
